import React, { useState } from "react";

const InputRadio = ({ name, title, onChange, value, checked }) => {
  const [id, setId] = useState(uuidv4());

  return (
    <>
      <input
        type="radio"
        name={name}
        value={value}
        id={id}
        style={{ marginRight: 10 }}
        onChange={onChange}
        defaultChecked={checked}
      />
      <label htmlFor={id}>{title}</label>
    </>
  );
};

const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
};

export default InputRadio;